import angular from "angular"

angular
  .module("appModule")
  .controller("FormularioEstadoController", FormularioEstadoController)
  .controller("FormularioEditarAntecedentesController", FormularioEditarAntecedentesController)
  .controller("FormularioComentarioController", FormularioComentarioController)
  .controller("FormularioListaDNIController", FormularioListaDNIController)

FormularioEstadoController.$inject = [
  "$scope",
  "$mdDialog",
  "EstadoMatriculaService",
  "saveCallback",
  "alumno"
]
function FormularioEstadoController(
  $scope,
  $mdDialog,
  EstadoMatriculaService,
  saveCallback,
  alumno
) {
  var self = $scope

  if (!alumno) {
    self.alumno = 0
  } else {
    self.alumno = alumno
  }

  self.estadosDict = {}

  EstadoMatriculaService.get().$promise.then(function(data) {
    self.estados = data.results
    self.selectedEstado = "" + self.alumno.estado_id
    for (var i = 0; i < self.estados.length; i++) {
      self.estadosDict["" + self.estados[i].id] = self.estados[i].nombre
    }
  })

  self.comentario = ""

  self.modificarEstado = function() {
    var post_data = {
      id: self.alumno.id,
      estado_id: self.selectedEstado,
      estado_desc: self.estadosDict[self.selectedEstado],
      comentario: self.comentario
    }

    saveCallback(post_data)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioEditarAntecedentesController.$inject = [
  "$scope",
  "$mdDialog",
  "saveCallback",
  "alumno",
  "datosEditables"
]
function FormularioEditarAntecedentesController(
  $scope,
  $mdDialog,
  saveCallback,
  alumno,
  datosEditables
) {
  var self = $scope
  self.alumno = alumno
  self.alumno_form = {}

  self.datosEditables = datosEditables

  angular.copy(self.alumno, self.alumno_form)

  self.editarAlumno = function() {
    var r = saveCallback(self.getAlumnoChanges())
    // Close modal then the callback resolves
    r.then(function() {
      self.cancelar()
    })
  }

  self.getAlumnoChanges = function() {
    var post_data = {
      id: self.alumno.id
    }

    var properties = Object.keys(self.alumno)

    for (var i = 0; i < properties.length; i++) {
      var key = properties[i]
      if (key == "id") {
        continue
      }
      if (self.alumno_form[key] !== self.alumno[key]) {
        post_data[key] = self.alumno_form[key]
      }
    }

    return post_data
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}
FormularioComentarioController.$inject = ["$scope", "$mdDialog"]
function FormularioComentarioController($scope, $mdDialog) {
  var self = $scope

  self.comentario = ""

  self.agregarComentario = function() {
    console.log("agregar comentario")
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioListaDNIController.$inject = ["$scope", "$rootScope", "$mdDialog"]
function FormularioListaDNIController($scope, $rootScope, $mdDialog) {
  var self = $scope
  var listCopy

  self.onChangeDNIListModel = () => {
    if (self.dniListModel.length) {
      listCopy = self.dniListModel.replace(/(\r\n\t|\n|\r\t)/gm, " ")
    }
    $rootScope.$broadcast("onDNIListChange", listCopy)
    $mdDialog.hide()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}
